export const studentRoomsNames: string[] = [
    'Аист',
    'Бекас',
    'Беркут',
    'Воробей',
    'Ворон',
    'Синица',
    'Лазоревка',
    'Чибис',
    'Голубь',
    'Грач',
    'Дрозд',
    'Дрофа',
    'Жаворонок',
    'Журавль',
    'Зарянка',
    'Иволга',
    'Коршун',
    'Кедровка',
    'Лебедь',
    'Пеликан',
    'Рябчик',
    'Снегирь',
    'Стриж',
    'Сойка',
    'Сорока',
    'Гаичка',
    'Киви',
    'Колибри',
    'Орёл',
    'Павлин',
    'Пингвин',
    'Сова',
    'Фазан',
    'Цапля',
    'Фламинго',
    'Кукушка',
    'Ласточка',
    'Грифон',
    'Попугай',
    'Кондор',
];

export enum TEACHER_QUIZ_MODE {
    START_SCREEN = 'startScreen',
    QUESTION = 'question',
    STATISTICS = 'statistics',
    FINAL_SCREEN = 'final_screen',
}
